var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { SharePopoverBodyWrapper, SharePopoverHeader, SharePreviewSection, SharePreviewHeading, InviteSection, InviteHeading, InviteContent, ShareLinkInput, CopyLinkWrapper, } from './styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserPlus } from '@fortawesome/pro-regular-svg-icons/faUserPlus';
import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck';
import { faPaste } from '@fortawesome/pro-regular-svg-icons/faPaste';
import { faSpinner } from '@fortawesome/pro-regular-svg-icons/faSpinner';
import { Button } from '@appspotr/ui-kit';
var SharePopOverBody = function (_a) {
    var appId = _a.appId, handleInviteModalOpen = _a.handleInviteModalOpen;
    var _b = useState(false), isCopied = _b[0], setIsCopied = _b[1];
    var previewUrl = "https://dev-mode-".concat(appId).concat(process.env.APP_BASE_URL);
    var copyToClipboard = function () {
        navigator.clipboard.writeText(previewUrl);
        setIsCopied(!isCopied);
        setTimeout(function () {
            setIsCopied(false);
        }, 5000);
    };
    return (_jsxs(SharePopoverBodyWrapper, __assign({ onClick: function (e) { return e.stopPropagation(); } }, { children: [_jsx(SharePopoverHeader, { children: "Share Project" }), _jsxs(SharePreviewSection, { children: [_jsx(SharePreviewHeading, { children: "Share preview link" }), _jsx("div", { children: "Anyone with the link can view the App. but won\u2019t be able to edit it" }), _jsxs(CopyLinkWrapper, { children: [_jsx(ShareLinkInput, { onClick: function (event) { return event.target.select(); }, value: appId ? previewUrl : 'Loading...' }), _jsx(Button, __assign({ onClick: copyToClipboard, style: {
                                    backgroundColor: '#07285B',
                                    border: 'none',
                                    minWidth: '35px',
                                    width: '35px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                } }, { children: _jsx(FontAwesomeIcon, { spin: !appId, icon: appId ? (isCopied ? faCheck : faPaste) : faSpinner, color: "#fff" }) }))] })] }), _jsxs(InviteSection, { children: [_jsx(InviteHeading, { children: "Invite App Admins" }), _jsxs(InviteContent, { children: [_jsx("div", { children: "Invite App admins to collaborate on your project. they will be able to access and edit the project according to their roles." }), _jsx(Button, __assign({ iconLeft: faUserPlus, onClick: handleInviteModalOpen }, { children: "Invite" }))] })] })] })));
};
export default SharePopOverBody;
